import {push} from '../core/redux/router'
import {linkFinder} from '../core/links'
import {infoStatus} from '../core/redux/status'
import {DEFAULT_TICKET_QUERY, loadTicketStream} from '../ticket/actions'
import {DEFAULT_QUERY, DEFAULT_PROVIDER_COVERAGE_QUERY, DEFAULT_CONTACT_STATS_QUERY, DEFAULT_PROVIDER_QUERY, loadContact, loadProviderStream, loadProviderCoverage, updateDefineUpdateInterventionPeriodForActivityCmd, updateProviderCoverageCriteria} from './actions'
import {TIME_SLOT_TYPES} from './models'
import i18n from './i18n'

function providerCriteriaUpdated() {
    var criteria

    return (state, dispatch) => {
        var nextCriteria = state.provider.criteria

        if (nextCriteria != criteria) {

            if (nextCriteria.activityUid != (criteria && criteria.activityUid)) {
                dispatch(loadProviderStream({...DEFAULT_QUERY, ...nextCriteria})).then(() => {
                    if (location.pathname != '/providers' || location.pathname != '/providerdirectory') {
                        return dispatch(push('/*'))
                    }
                })
            }
            criteria = nextCriteria
        }
    }
}

function providerCoverageCriteriaUpdated() {
    var criteria

    return (state, dispatch) => {
        var nextCriteria = state.provider.coverage.criteria

        if (criteria === undefined) {
            // state initial value
            criteria = nextCriteria
        }

        if (nextCriteria != criteria) {

            if (nextCriteria.activityUids.length == 0) {
                nextCriteria = criteria
                dispatch(updateProviderCoverageCriteria(nextCriteria))
                dispatch(infoStatus(i18n.coverageActivityIsRequired))
            }

            if (nextCriteria.zipCodes != (criteria && criteria.zipCodes)) {
                if (nextCriteria.zipCodes == null) {
                    dispatch(loadProviderCoverage({...DEFAULT_PROVIDER_COVERAGE_QUERY, ...nextCriteria}))
                }
            }

            if (nextCriteria.activityUids != (criteria && criteria.activityUids)
                || nextCriteria.department != (criteria && criteria.department)
                || nextCriteria.city != (criteria && criteria.city)) {
                dispatch(loadProviderCoverage({...DEFAULT_PROVIDER_COVERAGE_QUERY, ...nextCriteria}))
            }
            criteria = nextCriteria
        }
    }
}

function contactFilterUpdated() {
    var filter

    return (state, dispatch) => {
        const nextFilter = state.provider.contact.contactFilter

        if (nextFilter != filter) {
            const {contact} = state.provider.contact
            const _appLinks = state.app._links

            dispatch(loadContact(null, {...DEFAULT_CONTACT_STATS_QUERY,  ...nextFilter}))

            if (location.pathname.match(/\/providercontacts\/[\w-]+\/tickets/) != null) {
                dispatch(loadTicketStream({...DEFAULT_TICKET_QUERY, ...nextFilter, activeProviders: contact.uid}))
            } else {
                // dashboard
                _appLinks.find(linkFinder('tickets')) && dispatch(loadTicketStream({...DEFAULT_TICKET_QUERY, ...nextFilter, activeProviders: contact.uid, range: {offset: 0, limit: 0}}))
            }

            filter = nextFilter
        }
    }
}

function defineUpdateInterventionPeriodForActivityCmdUpdated() {
    var cmd

    function ensureTimeSlots(array) {
        return array && array.map((object) => {
            if (!object.timeSlot) {
                return {
                    timeSlot: {timeSlotType: TIME_SLOT_TYPES[0]},
                    ...object
                }
            }
            return object
        })
    }

    function ensureTimeSlot(timeSlot) {
        return timeSlot || {timeSlotType: TIME_SLOT_TYPES[0]}
    }

    return (state, dispatch) => {
        var nextCmd = state.provider.defineUpdateInterventionPeriodForActivityCmd

        if (nextCmd != cmd) {

            if (nextCmd && nextCmd.period && nextCmd.period.periodType != (cmd && cmd.period && cmd.period.periodType)) {
                switch(nextCmd.period.periodType) {
                    case 'DateTimePeriod':
                        nextCmd = {period: {...nextCmd.period, periodRanges: null, exclusions: null, days: null, timeSlot: null}}
                        dispatch(updateDefineUpdateInterventionPeriodForActivityCmd(nextCmd))
                        break
                    case 'WeekDaysPeriod':
                        nextCmd = {period: {...nextCmd.period, days: null, timeSlot: null}}
                        dispatch(updateDefineUpdateInterventionPeriodForActivityCmd(nextCmd))
                        break
                    case 'SpecificDaysPeriod':
                        nextCmd = {period: {...nextCmd.period, timeSlot: ensureTimeSlot(nextCmd.period.timeSlot), startDate: null, endDate: null, periodRanges: null, exclusions: null}}
                        dispatch(updateDefineUpdateInterventionPeriodForActivityCmd(nextCmd))
                        break 
                }
            }

            if (nextCmd && nextCmd.period && nextCmd.period.periodRanges && nextCmd.period.periodRanges.length != (cmd && cmd.period && cmd.period.periodRanges && cmd.period.periodRanges.length)) {
                nextCmd = {period: {...nextCmd.period, periodRanges: ensureTimeSlots(nextCmd.period.periodRanges)}}
                dispatch(updateDefineUpdateInterventionPeriodForActivityCmd(nextCmd))
            }

            if (nextCmd && nextCmd.period && nextCmd.period.exclusions && nextCmd.period.exclusions.length != (cmd && cmd.period && cmd.period.exclusions && cmd.period.exclusions.length)) {
                nextCmd = {period: {...nextCmd.period, exclusions: ensureTimeSlots(nextCmd.period.exclusions)}}
                dispatch(updateDefineUpdateInterventionPeriodForActivityCmd(nextCmd))
            }

            cmd = nextCmd
        }
    }
}

export default [providerCriteriaUpdated(), providerCoverageCriteriaUpdated(), contactFilterUpdated(), defineUpdateInterventionPeriodForActivityCmdUpdated()]


// WEBPACK FOOTER //
// ./lib/provider/actors.js